// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1ewVt","rightAdornment":"Header_rightAdornment__2xUzq"};